import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { cheminConnexion } from '../utils/redirectionConnexion';
import { useAuth } from '../context/AuthContext';

interface RequirePermissionProps {
  permission?: string;
  permissions?: string[];
  redirectTo?: string;
  children?: React.ReactNode;
}

const RequirePermission: React.FC<RequirePermissionProps> = ({
  permission,
  permissions,
  redirectTo = '/',
  children,
}) => {
  const { hasPermission, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Chargement...</div>; // Or a proper spinner
  }

  if (!isAuthenticated) {
    return <Navigate to={cheminConnexion(location.pathname, location.search)} replace />;
  }

  const hasAccess = permissions && permissions.length > 0
    ? permissions.some((p) => hasPermission(p))
    : permission
    ? hasPermission(permission)
    : true;

  if (!hasAccess) {
    return <Navigate to={redirectTo} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default RequirePermission;
